<div [ngClass]="state=='open' ? 'main_content_open' : 'main_content'">
  <p-scrollPanel [style]="{width: '100%', height: '95vh','margin-top':'7px','padding-bottom':'70px'}" #sc>
    <div class="p-d-flex p-jc-between p-ai-center p-pt-3 p-pb-3">
      <div class="page_title">Manage Holidays</div>
      <div>
        <p-breadcrumb [model]="items" [home]="home"></p-breadcrumb>
      </div>
    </div>
    <p-card>
      <div class="toolbar">
        <div class="p-grid p-ai-center">
          <div class="p-col p-md-6 p-lg-12 p-jc-end d-flex">
            <button pButton pRipple type="button" label="Fetch Year"
              class="p-button-raised p-button-outlined" style="font-size: 12px; margin-right: 8px;" icon="pi pi-cloud-download"
              (click)="showFetchDialog()"></button>
            <button pButton pRipple type="button" label="Add Holiday"
              class="p-button-raised" style="font-size: 12px;" icon="pi pi-plus"
              (click)="showAddDialog()"></button>
          </div>
        </div>
      </div>
    </p-card>
    <p-card styleClass="p-mt-3">
      <div class="row form-group">
        <div class="col-sm-3">
          <label style="font-size: 12px; display: block;">Year</label>
          <p-dropdown [options]="uniqueYears" [(ngModel)]="selectedListYear" optionLabel="label" optionValue="value"
            (onChange)="applyYearFilter()" [style]="{'width':'100%'}" placeholder="Select Year"></p-dropdown>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-12">
          <p-table [value]="filteredHolidays"
            styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped"
            [autoLayout]="true" [responsive]="true" [rowHover]="true">
            <ng-template pTemplate="header">
              <tr style="font-size: small;">
                <th style="width: 45%;">Name</th>
                <th style="width: 35%;">Date</th>
                <th style="width: 20%;">Action</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-holiday>
              <tr style="font-size: smaller;">
                <td>{{holiday.name}}</td>
                <td>{{holiday.date | date:'MMMM d, yyyy'}}</td>
                <td class="last_border">
                  <a href="javascript:void(0);" (click)="openEditDialog(holiday)">
                    <i class="pi pi-pencil" style="font-size: 0.8rem;color:#007AFF"></i>
                  </a>
                  &nbsp;
                  <a href="javascript:void(0);" (click)="confirmDeleteDialog(holiday)">
                    <i class="pi pi-trash" style="font-size: 0.8rem;color:#dc3545"></i>
                  </a>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="3">
                  <div *ngIf="isLoading" class="alignCenter">
                    <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3">
                    </p-progressSpinner>
                  </div>
                  <p-messages *ngIf="filteredHolidays?.length == 0 && !isLoading" key="listMsg" class="alignCenter">
                    <ng-template pTemplate>
                      <i class="pi pi-copy" style="font-size: 2rem"></i>
                      <div class="p-ml-2">NO HOLIDAYS FOUND{{selectedListYear ? ' FOR ' + selectedListYear : ''}}</div>
                    </ng-template>
                  </p-messages>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-card>
  </p-scrollPanel>
</div>

<!-- ─── ADD / EDIT HOLIDAY MODAL ─── -->
<p-dialog #addEditDialog [header]="editMode ? 'Edit Holiday' : 'Add Holiday'" [(visible)]="displayAddEditModal" [modal]="true" [baseZIndex]="10000"
  [draggable]="false" [resizable]="true" styleClass="p-fluid" [contentStyle]="{'overflow':'visible'}"
  (onHide)="clearFormData()" (onShow)="showDialogMaximized($event, addEditDialog)">
  <p-messages key="errMsg" [style]="{'font-size': '12px'}"></p-messages>
  <form role="form" style="min-width: 40vw;">
    <div class="row">
      <div class="form-group col-md-6">
        <label>Holiday Name<span class="symbol required"></span></label>
        <input type="text" class="form-control border-black" name="holidayName" placeholder="Enter Holiday Name"
          [(ngModel)]="holidayName" required autocomplete="off" />
      </div>
      <div class="form-group col-md-6">
        <label>Date<span class="symbol required"></span></label>
        <p-calendar [(ngModel)]="holidayDate" name="holidayDate" inputId="holidayDate"
          [showButtonBar]="true" [showIcon]="true" [readonlyInput]="true"
          placeholder="Select date"></p-calendar>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-times" (click)="displayAddEditModal = false" label="Cancel"
      styleClass="p-button-danger p-button-text"></p-button>
    <p-button [icon]="editMode ? 'pi pi-save' : 'pi pi-plus'" (click)="saveHoliday()" [label]="editMode ? 'Save' : 'Add'" [disabled]="disabled"></p-button>
  </ng-template>
  <div *ngIf="isLoading" class="progressLayout">
    <div class="progressContainer">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3"></p-progressSpinner>
    </div>
  </div>
</p-dialog>

<!-- ─── FETCH YEAR MODAL ─── -->
<p-dialog #fetchDialog header="Fetch Holidays for Year" [(visible)]="displayFetchModal" [modal]="true" [baseZIndex]="10000"
  [draggable]="false" [resizable]="true" [maximizable]="true"
  (onShow)="showDialogMaximized($event, fetchDialog)">
  <div style="min-width: 50vw;">
    <div class="row" style="align-items: flex-end;">
      <div class="form-group col-md-6">
        <label>Year</label>
        <p-dropdown [options]="fetchYearOptions" [(ngModel)]="selectedFetchYear" optionLabel="label" optionValue="value"
          appendTo="body" [baseZIndex]="10001" [style]="{'width':'100%'}"></p-dropdown>
      </div>
      <div class="form-group col-md-6">
        <button pButton pRipple type="button" label="Fetch" icon="pi pi-cloud-download"
          [disabled]="isFetching" (click)="fetchForYear()"></button>
      </div>
    </div>

    <div *ngIf="isFetching" class="alignCenter" style="padding: 20px 0;">
      <p-progressSpinner [style]="{ width: '32px', height: '32px' }" strokeWidth="3"></p-progressSpinner>
    </div>

    <p-messages *ngIf="fetchBlockedMessage" severity="error" [closable]="false">
      <ng-template pTemplate>
        <div>{{fetchBlockedMessage}}</div>
      </ng-template>
    </p-messages>

    <p-messages *ngIf="fetchAttempted && !isFetching && !fetchBlockedMessage && fetchResults.length === 0" severity="warn" [closable]="false">
      <ng-template pTemplate>
        <div>No public holidays found for this year.</div>
      </ng-template>
    </p-messages>

    <div *ngIf="fetchResults.length > 0" style="max-height: 320px; overflow-y: auto; margin-top: 10px;">
      <table class="table">
        <thead>
          <tr>
            <th style="width: 15%;">Include</th>
            <th style="width: 45%;">Name</th>
            <th style="width: 40%;">Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let result of fetchResults; let i = index">
            <td><p-checkbox [(ngModel)]="result.checked" [binary]="true" [name]="'fetch_' + i"></p-checkbox></td>
            <td>{{result.name}}</td>
            <td>{{result.date | date:'MMMM d, yyyy'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-times" (click)="displayFetchModal = false" label="Cancel"
      styleClass="p-button-danger p-button-text"></p-button>
    <p-button icon="pi pi-check" (click)="confirmBulkAdd()" label="Confirm" [disabled]="disabled || fetchResults.length === 0"></p-button>
  </ng-template>
  <div *ngIf="isLoading" class="progressLayout">
    <div class="progressContainer">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3"></p-progressSpinner>
    </div>
  </div>
</p-dialog>

<!-- ─── DELETE CONFIRMATION ─── -->
<p-confirmDialog [baseZIndex]="10000" rejectButtonStyleClass="p-button-text" [style]="{width:'45vw'}">
</p-confirmDialog>
